export const MENU_MOBILE_BREAK_POINT = 1267;

export default MENU_MOBILE_BREAK_POINT;
